import { render } from "./Dashbord.vue?vue&type=template&id=d5f01106"
import script from "./Dashbord.vue?vue&type=script&lang=js"
export * from "./Dashbord.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__